import React, { useId } from 'react'
import {
    AreaChart, Area, XAxis, YAxis, Tooltip,
    ResponsiveContainer, CartesianGrid
} from 'recharts'
import styles from "../charts.module.css"
import { formatValueWithUnit } from '../chartUtils'

const ChartArea = ({ data, color = "#7B61FF", unit = "" }) => {
    const gradientId = useId().replace(/:/g, "")
    const allDataZero = data.every(item => item.value === 0)

    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            const item = payload[0].payload
            return (
                <div className={styles.tooltip}>
                    <p>
                        <span className={styles.tooltipLabel}>{item.name}</span>
                        <span className={styles.tooltipValue}>{item.formattedValue || formatValueWithUnit(item.value, unit)}</span>
                    </p>
                </div>
            )
        }
        return null
    }

    return allDataZero ? (
        <div className={styles.emptyChartMessage}><p>Nenhum dado para exibir</p></div>
    ) : (
        <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={data} margin={{ top: 14, right: 16, left: 8, bottom: 8 }}>
                <defs>
                    <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
                        <stop offset="5%" stopColor={color} stopOpacity={0.32} />
                        <stop offset="95%" stopColor={color} stopOpacity={0.03} />
                    </linearGradient>
                </defs>
                <CartesianGrid strokeDasharray="4 8" stroke="var(--border-subtle-color)" vertical={false} />
                <XAxis
                    dataKey="name"
                    axisLine={false}
                    tickLine={false}
                    minTickGap={22}
                    tick={{ fill: "var(--text-secondary)", fontSize: 12, fontWeight: 600 }}
                />
                <YAxis
                    width={34}
                    axisLine={false}
                    tickLine={false}
                    tick={{ fill: "var(--text-secondary)", fontSize: 11, fontWeight: 600 }}
                    tickFormatter={(value) => new Intl.NumberFormat("pt-BR", {
                        notation: Math.abs(value) >= 10000 ? "compact" : "standard",
                        maximumFractionDigits: 1
                    }).format(value)}
                />
                <Tooltip content={<CustomTooltip />} offset={12} wrapperStyle={{ outline: "none" }} />
                <Area
                    type="monotone"
                    dataKey="value"
                    stroke={color}
                    fill={`url(#${gradientId})`}
                    strokeWidth={3}
                    activeDot={{ r: 7, strokeWidth: 3, fill: color, stroke: "var(--surface-card)" }}
                />
            </AreaChart>
        </ResponsiveContainer>
    )
}

export default ChartArea
